<template>
  <div class="notification__container">
    <v-menu width="37.5em" offset-y>
      <template v-slot:activator="{ on }">
        <v-badge :color="unreadCount > 0 ? 'red' : 'transparent'">
          <template v-slot:badge>
            <span>{{ unreadCount > 0 ? unreadCount : "" }}</span>
          </template>

          <v-btn color="primary" dark icon v-on="on">
            <v-icon color="white">notifications</v-icon>
          </v-btn>
        </v-badge>
      </template>

      <v-card>
        <v-progress-linear
          color="primary"
          class="ma-0"
          height="3"
          :indeterminate="loading"
        />

        <v-card-title class="headline">
          Notifications

          <v-spacer />

          <v-btn
            flat
            small
            class="caption"
            style="text-decoration: underline"
            @click.stop="markAllAsRead"
          >
            MARK ALL AS READ
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-list class="notification-popover__container" two-line>
          <template v-for="(item, index) in notifications">
            <v-list-tile
              :key="item.title"
              avatar
              @click="goToNotification(item)"
            >
              <v-list-tile-avatar>
                <v-icon
                  :title="!item.read_at && 'Mark as read'"
                  :color="!item.read_at ? 'success' : ''"
                  @click.self.stop="markAsRead(item)"
                >
                  sms
                </v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.data.title }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{
                  item.data.message
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-list-tile-action-text>{{
                  calculateTime(item.created_at)
                }}</v-list-tile-action-text>
              </v-list-tile-action>
            </v-list-tile>

            <v-divider :key="index" />
          </template>

          <div
            v-if="notifications.length === 0"
            class="mt-4"
            style="text-align: center; color: rgba(0, 0, 0, 0.5)"
          >
            Empty
          </div>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";

export default {
  data() {
    return {
      unreadCount: undefined,
      position: "top",
      loading: false,
      notifications: []
    };
  },

  created() {
    this.initOneSignal();

    this.getNotifications();
  },

  methods: {
    initOneSignal() {
      window.OneSignal.push(() => {
        window.OneSignal.on("notificationDisplay", () => {
          // console.log("OneSignal notification displayed:", event);
          this.getNotifications();
        });
      });
    },

    async getNotifications() {
      try {
        this.loading = true;

        const res = await api.getNotifications();

        this.unreadCount =
          res.data.unread_count > 0 ? res.data.unread_count : undefined;
        this.notifications = res.data.notifications || [];
      } finally {
        this.loading = false;
      }
    },

    convertTime(utcStr) {
      return moment
        .parseZone(utcStr, "YYYY-MM-DD HH:mm:ss", "UTC")
        .toDate()
        .toLocaleString();
    },

    calculateTime(utcStr) {
      let duration = moment.duration(
        moment().diff(moment(moment.utc(utcStr, "YYYY-MM-DD HH:mm:ss")))
      );

      if (duration.asYears() > 1) {
        let year = parseInt(duration.asYears(), 10);
        return `${year}Y`;
      } else if (duration.asMonths() > 1) {
        let month = parseInt(duration.asMonths(), 10);
        return `${month}M`;
      } else if (duration.asWeeks() > 1) {
        let week = parseInt(duration.asWeeks(), 10);
        return `${week}w`;
      } else if (duration.asDays() > 1) {
        let day = parseInt(duration.asDays(), 10);
        return `${day}d`;
      } else if (duration.asHours() > 1) {
        let hour = parseInt(duration.asHours(), 10);
        return `${hour}h `;
      } else if (duration.asMinutes() > 1) {
        let min = parseInt(duration.asMinutes(), 10);
        return `${min}m`;
      } else {
        return "now";
      }
    },

    markAsRead(item) {
      if (item.read_at) return;

      item.read_at = new Date().toISOString();
      this.unreadCount--;

      api.markAsRead(item.id);
    },

    goToNotification(item) {
      this.markAsRead(item);

      if (item.type === "App\\Notifications\\ComplaintCreated") {
        this.$router.push("/complaints?logs=" + item.data.complaint_id);
      } else if (item.type === "App\\Notifications\\ComplaintResolved") {
        this.$router.push("/complaints?logs=" + item.data.complaint_id);
      } else if (item.type === "App\\Notifications\\UserRegistered") {
        this.$router.push("/staffs");
      }
    },

    markAllAsRead() {
      this.notifications.forEach(n => this.markAsRead(n));
    }
  }
};
</script>
<style lang="css" scoped>
.notification__container {
  z-index: 2000;
}

.notification-popover__container {
  min-width: 18.75em;
  min-height: 6.25em;
  max-height: 37.5em;
  overflow-y: auto;
}
</style>

<style lang="css">
.notification__container .v-badge__badge {
  top: -0.0625em;
  right: -0.0625em;
}
</style>
